module.exports = __webpack_public_path__ + "static/media/Central-India.ab4f790a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backs/Central-India.jpg
// module id = 1008
// module chunks = 0